import ToolkitForm from 'mcs-toolkit/components/Form';
import React from 'react';
import { FormProps as $FormProps } from 'semantic-ui-react';

import { FieldCommonErrorMessages } from 'reactComponents/Forms/FieldCommonErrorMessages/FieldCommonErrorMessages';

type OwnProps = $FormProps & {
    noCommonErrorMessages?: boolean;
};

export type FormProps = OwnProps;

export const Form = (props: FormProps) => {
    const { children, noCommonErrorMessages, ...restProps } = props;
    return (
        <ToolkitForm {...restProps}>
            {children}

            {!noCommonErrorMessages && <FieldCommonErrorMessages />}
        </ToolkitForm>
    );
};
